import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './ContactPage.css';

function ContactPage() {
  const [form, setForm] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    _honeypot: '',  // hidden trap field
  });
  const [status, setStatus] = useState({ kind: 'idle', error: null });

  const onChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (status.kind === 'sending') return;
    setStatus({ kind: 'sending', error: null });
    try {
      const res = await fetch('/api/contact/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (res.ok && data.ok) {
        setStatus({ kind: 'sent', error: null });
        setForm({ name: '', email: '', subject: '', message: '', _honeypot: '' });
      } else {
        setStatus({
          kind: 'error',
          error: data.error || 'Could not send. Please try again.',
        });
      }
    } catch (err) {
      setStatus({
        kind: 'error',
        error: 'Network error. Please try again.',
      });
    }
  };

  const bannerStyle = {
    backgroundImage: `url(/assets/NeXusNeuroClinical_syna.webp)`,
  };

  return (
    <main className="contact-page">
      <section className="contact-banner" style={bannerStyle}>
        <div className="contact-banner-overlay">
          <Link to="/" className="contact-back-banner">&larr; Home</Link>
          <img
            src="/assets/nexus_neuro_logo.webp"
            alt="NeXus NeuroInformatics, Inc."
            className="contact-banner-logo"
          />
          <h1 className="contact-banner-title">Contact</h1>
        </div>
      </section>

      <header className="contact-header">
        <p className="contact-deck">
          Send a message and it will land directly with the office of the CEO.
          We respond to research, regulatory, and partnership inquiries personally.
        </p>
      </header>

      <section className="contact-card">
        <form className="contact-form" onSubmit={onSubmit} noValidate>
          <div className="contact-row">
            <label htmlFor="cf-name">Name</label>
            <input
              id="cf-name"
              type="text"
              name="name"
              required
              maxLength={200}
              value={form.name}
              onChange={onChange}
              autoComplete="name"
              disabled={status.kind === 'sending'}
            />
          </div>

          <div className="contact-row">
            <label htmlFor="cf-email">Email</label>
            <input
              id="cf-email"
              type="email"
              name="email"
              required
              maxLength={320}
              value={form.email}
              onChange={onChange}
              autoComplete="email"
              disabled={status.kind === 'sending'}
            />
          </div>

          <div className="contact-row">
            <label htmlFor="cf-subject">Subject <span className="contact-optional">(optional)</span></label>
            <input
              id="cf-subject"
              type="text"
              name="subject"
              maxLength={200}
              value={form.subject}
              onChange={onChange}
              disabled={status.kind === 'sending'}
            />
          </div>

          <div className="contact-row">
            <label htmlFor="cf-message">Message</label>
            <textarea
              id="cf-message"
              name="message"
              required
              rows={6}
              maxLength={8000}
              value={form.message}
              onChange={onChange}
              disabled={status.kind === 'sending'}
            />
          </div>

          {/* Honeypot — hidden from real users, bots fill it, server drops on detection */}
          <div className="contact-honeypot" aria-hidden="true">
            <label htmlFor="cf-hp">Leave blank</label>
            <input
              id="cf-hp"
              type="text"
              name="_honeypot"
              tabIndex={-1}
              autoComplete="off"
              value={form._honeypot}
              onChange={onChange}
            />
          </div>

          <div className="contact-actions">
            <button type="submit" className="contact-submit" disabled={status.kind === 'sending'}>
              {status.kind === 'sending' ? 'Sending…' : 'Send message'}
            </button>
          </div>

          {status.kind === 'sent' && (
            <p className="contact-status contact-status-sent">
              Message sent. We will read it personally and reply if appropriate.
            </p>
          )}
          {status.kind === 'error' && (
            <p className="contact-status contact-status-error">
              {status.error}
            </p>
          )}
        </form>
      </section>

      <section className="contact-footer-note">
        <p>
          For matters involving the parent corporation, please visit{' '}
          <a href="https://nexusconcordat.com">nexusconcordat.com</a>.
        </p>
      </section>
    </main>
  );
}

export default ContactPage;
